module.exports = __webpack_public_path__ + "img/mission.1aab36a1.png";